import { getActivatedRules } from "./paymentHelper/paymentHelper.ts";

export const getCouponDiscount = (tickets: any[], coupon: any | undefined | null = null) => {
    let couponDiscount = 0;

    if (coupon) {
        let useDiscount = true;

        for (const ttId of coupon.ticketTypeIds) {
            if (tickets.filter(t => t.ticketTemplateId == ttId).length == 0) {
                useDiscount = false;
                break;
            }
        }

        if (useDiscount) {
            console.log(1);
            for (const ticket of tickets) {
                if (!coupon.ticketTypeIds || coupon.ticketTypeIds.length === 0) {
                    console.log(2);
                    couponDiscount += coupon.fixedDiscount;
                }
                else if (coupon.ticketTypeIds.filter(id => id == ticket.ticketTemplateId) > 0) {
                    console.log(3);
                    couponDiscount += coupon.fixedDiscount;
                }
            }
        }
    }

    return couponDiscount
}

export const getPriceInternal = (tickets: any[], ticketTemplates: any[], coupon: any | undefined | null = null) => {
    let price = 0;

    price = tickets.reduce((a, ticket) => {
        return a + ticket.getPrice();
    }, 0);

    return price - getCouponDiscount(tickets, coupon);
}

export const getPrice = (tickets: any[], ticketTemplates: any[], coupon: any, manualDiscount = 0): number => {
    const price = getPriceInternal(tickets, ticketTemplates, coupon) - manualDiscount;

    return +(price > 0 ? price : 0).toFixed(2)
}

export const applyDiscounts = (tickets: any[], ticketTemplates: any[]) => {
    const activatedRules = getActivatedRules(tickets, ticketTemplates);

    tickets.map(t => t.rules = []);

    for (const rule of activatedRules) {
        for (const ticket of tickets.filter(t => t.ticketTemplateId === rule.ticketTemplateId)) {
            if (!ticket.rules) {
                ticket.rules = [];
            }

            ticket.rules.push(rule);
        }
    }
}

export const getTotalFee = (tickets: any[], fixedFeeRate: number, feeRate: number, ticketTemplates: any[], coupon: any, manualDiscount = 0) => {
    return tickets.length * fixedFeeRate + getPrice(tickets, ticketTemplates, coupon, manualDiscount) * feeRate;
}

export const getTotalPaymentAmount = (tickets: any[], eventInfo: any, coupon: any = null) => {
    const price = getPrice(tickets, eventInfo.ticketTemplates, coupon);
    const totalFee = getTotalFee(tickets, eventInfo.fixedFeeRate, eventInfo.feeRate, eventInfo.ticketTemplates, coupon, 0);

    return {
        total: price + totalFee,
        price,
        totalFee,
    }
}